import i18next from "../../../i18n";

i18next.addResourceBundle("en", "PermissionTable", {
    name: "Name",
    uname: "Uname",
    user: "Ditto User",
    type: "Type",
    edit: "Edit",
    configure: "Configure",
});

i18next.addResourceBundle("fr", "PermissionTable", {
    name: "Nom",
    uname: "Uname",
    user: "Ditto Utilisateur",
    type: "Type",
    edit: "Modifier",
    configure: "Configurer",
});
